export default class ScoreTracker {

    constructor(){
      this.totalNotesInSong = 0
      this.totalKeysPlayed = 0
      this.correctKeysPlayed = 0
      this.calculatePercentage = this.calculatePercentage.bind(this)
    }

    keyPressed = (correctKey) => {
        if(correctKey)
            this.correctKeysPlayed++;
        this.totalKeysPlayed++;
    };

    calculatePercentage = () => {
      if (this.totalNotesInSong === 0) {
        return 0;
      }
      let wrong = this.totalKeysPlayed - this.correctKeysPlayed
      let right = this.correctKeysPlayed
      let score = (right - wrong)/this.totalNotesInSong
      return Math.max(0, score * 100);
    };

    reset = (totalNotesInSong) => {
      this.totalNotesInSong = totalNotesInSong;
      this.totalKeysPlayed = 0;
      this.correctKeysPlayed = 0;
    }

    getPercentage = () => {
        return this.calculatePercentage().toFixed(0);
    }
}
